import React, { useCallback, useMemo } from "react";
import styled from "styled-components";
import renderIf from "render-if";
import Typography from "@material-ui/core/Typography";

import isError from "../utils/is-error";
import YMMTSelect from "../components/YMMTSelect";
import useYMMTMaps from "../hooks/useYMMTMaps";

const useCreateMapList = (map) => {
  return useMemo(() => {
    if (!map) return undefined;

    // Find the duplicate make values because of the truck id hack,
    // This will allow use to still store the different truck make id and the `-' combo id
    // In the main data store, but will allow the selector only to display one make value.
    // This prevents having Chevy in the drop down 3x because of ids 7, 8. and 7-8
    const dashInString = /-/g;

    const idsToRemoveSet = new Set(
      Array.from(map.keys())
        .filter((id) => dashInString.test(id))
        .map((id) => id.split(dashInString))
        .reduce((a, b) => [...a, ...b], [])
    );
    return Array.from(map)
      .filter(([id]) => !idsToRemoveSet.has(id))
      .sort(([, a], [, b]) => b - a)
      .map(([value, name]) => ({ name, value }));
  }, [map]);
};

const Error = styled(Typography).attrs({ variant: "h5", color: "error" })``;

const YMMTSelectContainer = ({ name, onChange, franchises, ...props }) => {
  const { values = {} } = props.form;
  const { ymmtIds = {} } = values;

  const handleChange = useCallback(
    (evt) => {
      const { target } = evt;
      const { value } = target;
      onChange({ target: { name, value } });
    },
    [name, onChange]
  );

  const [{ years, makes, models, trims }] = useYMMTMaps(ymmtIds);

  return (
    <>
      <YMMTSelect
        {...ymmtIds}
        franchises={franchises}
        years={useCreateMapList(years)}
        makes={useCreateMapList(makes)}
        models={useCreateMapList(models)}
        trims={useCreateMapList(trims)}
        onChange={handleChange}
        {...props}
      />
      {renderIf(
        isError(years) || isError(makes) || isError(models) || isError(trims)
      )(
        <Error>
          There seems to be a issue looking up year, make, model, trim
          information. Please use Search By VIN or try again at another time.
        </Error>
      )}
    </>
  );
};

export default YMMTSelectContainer;
